import React from 'react';

function EmptyTodos() {
	return <p>Creat tu primer TODO...</p>;
}

export { EmptyTodos };
